/*
 * WorkAndBuhin.vue の resetBuhin/hideBuhin/showMsgConfirm など外部公開操作の状態変更を切り出した処理。
 */
export interface WorkBuhinResetPublicState {
  listSelectedBuhin: any[];
  listManualBuhinFiltered: any[];
  shouldMapBuhin: boolean;
}

export interface ResetBuhinApplyEffectState {
  listSelectedBuhin: any[];
  listManualBuhinFiltered: any[];
  shouldMapBuhin: boolean;
}

export interface ResetBuhinCommitApplyEffectState {
  listSelectedBuhin: any[];
  listManualBuhinFiltered: any[];
  shouldMapBuhin: boolean;
}

export interface WorkBuhinHidePublicState {
  showBuhin: boolean;
}

export interface WorkBuhinConfirmMessageState {
  message: string;
  focusElementId: string;
}

export interface WorkBuhinConfirmFocusTargetState {
  shouldFocus: boolean;
  target: any;
}

/*
 * buildResetBuhinPublicState を WorkAndBuhin.vue から分離し、
 * public/ref API 互換 を親側置換や単体テストで固定するため。
 */
export function buildResetBuhinPublicState(): WorkBuhinResetPublicState {
  return {
    listSelectedBuhin: [],
    listManualBuhinFiltered: [],
    shouldMapBuhin: true
  };
}

/*
 * buildResetBuhinApplyEffectState を WorkAndBuhin.vue から分離し、
 * resetBuhin の component 側反映値と mapBuhin 実行条件を固定するため。
 */
export function buildResetBuhinApplyEffectState(
  resetState: WorkBuhinResetPublicState
): ResetBuhinApplyEffectState {
  return {
    listSelectedBuhin: resetState.listSelectedBuhin,
    listManualBuhinFiltered: resetState.listManualBuhinFiltered,
    shouldMapBuhin: resetState.shouldMapBuhin
  };
}

/*
 * buildResetBuhinCommitApplyEffectState を WorkAndBuhin.vue から分離し、
 * resetBuhin の component 側 list 反映と mapBuhin 実行条件を固定するため。
 */
export function buildResetBuhinCommitApplyEffectState(
  effectState: ResetBuhinApplyEffectState
): ResetBuhinCommitApplyEffectState {
  return {
    listSelectedBuhin: effectState.listSelectedBuhin,
    listManualBuhinFiltered: effectState.listManualBuhinFiltered,
    shouldMapBuhin: effectState.shouldMapBuhin
  };
}

/*
 * buildHideBuhinPublicState を WorkAndBuhin.vue から分離し、
 * public/ref API 互換 を親側置換や単体テストで固定するため。
 */
export function buildHideBuhinPublicState(): WorkBuhinHidePublicState {
  return {
    showBuhin: false
  };
}

/*
 * buildWorkBuhinConfirmMessageState を WorkAndBuhin.vue から分離し、
 * public/ref API 互換 を親側置換や単体テストで固定するため。
 */
export function buildWorkBuhinConfirmMessageState(
  isBuhin: boolean
): WorkBuhinConfirmMessageState {
  return {
    message: isBuhin ? "部品確定しました" : "部品なしで確定しました",
    focusElementId: "btn-close-workbuhin"
  };
}

/*
 * buildWorkBuhinConfirmFocusTargetState を WorkAndBuhin.vue から分離し、
 * showMsgConfirm の DOM 検索後に focus を実行できる対象かどうかを固定するため。
 */
export function buildWorkBuhinConfirmFocusTargetState(
  target: any
): WorkBuhinConfirmFocusTargetState {
  return {
    shouldFocus: !!target,
    target
  };
}
